/* eslint-disable */
import React, { useEffect } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';

const FONT = "'Open Sans', sans-serif";

const SaveToast = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, [open]);

  if (!open) return null;

  return (
    <Box sx={{
      position: 'fixed',
      top: '24px',
      right: '24px',
      zIndex: 9999,
      backgroundColor: '#fff',
      borderRadius: '10px',
      boxShadow: '0px 8px 24px rgba(0,0,0,0.12)',
      borderLeft: '4px solid #27AE60',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
      px: '18px',
      py: '14px',
      minWidth: '280px',
      maxWidth: '340px',
      animation: 'slideIn 0.25s ease',
      '@keyframes slideIn': {
        from: { opacity: 0, transform: 'translateX(40px)' },
        to:   { opacity: 1, transform: 'translateX(0)' },
      },
    }}>
      <Box sx={{
        width: 32, height: 32, borderRadius: '50%',
        border: '2px solid #27AE60',
        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
      }}>
        <CheckCircleOutlineIcon sx={{ fontSize: 18, color: '#27AE60' }} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1A2B3C', fontFamily: FONT }}>
          Succès
        </Typography>
        <Typography sx={{ fontSize: '13px', color: '#8398AE', fontFamily: FONT, mt: '2px' }}>
          Informations sauvegardées avec succès
        </Typography>
      </Box>
      <IconButton onClick={onClose} size="small" sx={{ color: '#8398AE', p: '2px', mt: '-2px' }}>
        <CloseIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Box>
  );
};

export default SaveToast;